import React from 'react';
import { connect } from 'react-redux';

const userHasFeature = (me, feature) => {
    const featureFlag = me.enterprise?.enterprisePreferences.find((preference) => preference.token === feature);
    return featureFlag && featureFlag.booleanValue;
};

const FeatureAccess = ({ me, feature, children }) => {
    if (Array.isArray(children)) {
        const positiveChild = children.find((child) => child.props.hasfeature === 'true' || typeof child.props.hasfeature === "undefined");
        const negativeChild = children.find((child) => child.props.hasfeature === 'false');
        return userHasFeature(me, feature) ? <React.Fragment>{positiveChild}</React.Fragment> : (negativeChild ? <React.Fragment>{negativeChild}</React.Fragment> : null);
    } else {
        return userHasFeature(me, feature) ? <React.Fragment>{children}</React.Fragment> : null;
    }
};

export default connect((state) => ({ me: state.user.me }))(FeatureAccess);